import { render } from "./AddTariffZonePage.vue?vue&type=template&id=92dca07e&ts=true"
import script from "./AddTariffZonePage.vue?vue&type=script&lang=ts"
export * from "./AddTariffZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__